<template>
    <v-tab-item class="fill-height">
        <v-layout column justify-center class="h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">

                <div class="text-center mb-20 mb-lg-40">
                    <h3 class="tit mb-8 mb-lg-16">계약 대상자 선택</h3>
                    <p class="page-text--lg grey-6--text">근로계약을 체결할 대상자를 선택해 주세요.</p>
                </div>

                <v-card rounded="lg" flat color="grey-f7" class="mb-20 mb-lg-40" style="overflow: unset;">
                    <div class="pa-20 pa-md-30 pa-lg-40">
                        <v-row align="center" class="row--small">
                            <v-col cols="12" md="auto">
                                <v-select
                                    v-bind="attrs_input" 
                                    v-model="filter.searchKey"
                                    placeholder="성명,아이디,전화번호,이메일"
                                    :items=searchKeys
                                    item-text="text"
                                    item-value="value"
                                    />
                            </v-col>
                            <v-col>
                                <v-row class="row--small">
                                    <v-col>
                                        <v-text-field v-bind="attrs_input" v-model="filter.searchValue" placeholder="검색내용을 입력하세요." class="v-text-field--search">
                                            <template #prepend-inner>
                                                <v-btn icon text><i class="icon icon-search-black"></i></v-btn>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn color="grey-6" dark class="min-w-80px min-w-lg-100px" @click="search">검색</v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <div class="v-cards">
                    <employment-contract-item v-for="item in applications" :key="item?.id" :value="item" :recruitment="item.recruitment" :checkedApplicants="checkedApplicants"  @checkApplicant="getApplicants" /> 
                </div>

            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="cancel()"><span class="grey-6--text">취소</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save()"><span>저장하기</span></v-btn>
            </div>
            <!-- <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition> -->
        </v-layout>
    </v-tab-item>
</template>

<script>
import { attrs_input, } from "@/assets/variables";
import EmploymentContractItem from "@/components/dashboard/company/employment/contract/form/employment-contract-item.vue";
import api from '@/api';

export default {
    components: {
        EmploymentContractItem,
    },
    props:{
        applicants: { type: Array, default: [] } //최종 선택 대상자
    },
    data: () => ({
        attrs_input,
        filter: {
            code: "search",
            searchKey: null,
            searchValue: null,
        },
        searchKeys:[
            {
                value:"resume.personalInformation.name",
                text: '성명'
            },
            {
                value:"username",
                text: '아이디'
            },
            {
                value:"resume.personalInformation.phone",
                text: '전화번호'
            },
            {
                value:"resume.personalInformation.email",
                text: '이메일'
            },
        ],
        applications: [],
        checkedApplicants: []
    }),
    watch:{
        applicants(){
            this.checkedApplicants = [];
            this.checkedApplicants.push(...this.applicants);
        }
    },
    methods:{
        async search(){
            try{    
                let { skip, limit, sort } = this;
                const { summary,  applications } = await api.v1.company.recruitments.applications.gets({
                    headers: { skip, limit, sort },
                    params: { ...this.filter },
                    _recruitment: this.recruitmentId,
                });
                this.summary = summary;
                this.applications = applications;
                }
            catch (e){
                console.error(e)
            }
        },
        getApplicants(value){
            if(value){
                let idx = this.checkedApplicants.map(e=>e._id).indexOf(value._id);
                if(idx < 0){
                    this.checkedApplicants.push(value);
                } else{
                    this.checkedApplicants.splice(idx,1);
                }
            }
        },
        save(){
            this.cleanForm();
            this.$emit('checkedApplicants',this.checkedApplicants);
            this.$emit('main');
        },
        cancel(){
            this.cleanForm();
            this.checkedApplicants= [];
            this.checkedApplicants.push(...this.applicants);
            this.$emit('main');
        },
        cleanForm(){
            this.filter={
                code: "search",
                searchKey: null,
                searchValue: null,
            },
            this.applications= [];
        }
    }
};
</script>